import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPosCompanyHistory } from '../models/models'

export class ListPosCompanyHistoryApi extends ClientProxy {
  private readonly baseUrl = 'admin/posTransaction/listPosCompanyHistory'

  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransaction/listPosCompanyHistory',
      requesterInfo,
    })
  }

  public async listPosCompanyHistory(companyId: number, posId: number): Promise<IPosCompanyHistory[]> {
    this.props.url = `${this.baseUrl}/${companyId}/${posId}`
    return await this.getAsync<IPosCompanyHistory[]>()
  }
}